import { get } from "lodash";

export const limitUpsellIds = (limit = {}) => {
  const linked = get(limit, "upsells");
  if (Array.isArray(linked)) {
    return linked.map((upsell) => get(upsell, "id")).filter(Boolean);
  }
  const single = get(limit, "upsell.id");
  return single ? [single] : [];
};

export const toLimitInput = (limit = {}) => ({
  id: limit.id,
  code: limit.code || null,
  value: limit.value || null,
  upsells: limitUpsellIds(limit).map((id) => ({ id })),
});

export const resolveLimit = (limits, selectedUpsellIds = []) => {
  const candidates = limits || [];
  const selected = selectedUpsellIds || [];
  const matching = candidates.filter((limit) => {
    const linked = limitUpsellIds(limit);
    return linked.length > 0 && linked.every((id) => selected.includes(id));
  });
  if (matching.length) {
    return matching.reduce((best, limit) =>
      limitUpsellIds(limit).length > limitUpsellIds(best).length ? limit : best,
    );
  }
  return candidates.find((limit) => limitUpsellIds(limit).length === 0) || null;
};

const limitValue = (limit) => get(limit, "value.value");

export const isBoostedLimit = (limits, selectedUpsellIds = []) => {
  const resolved = resolveLimit(limits, selectedUpsellIds);
  if (!resolved || !limitUpsellIds(resolved).length) return false;
  const baseLimit = (limits || []).find(
    (limit) => limitUpsellIds(limit).length === 0,
  );
  if (!baseLimit) return true;
  return limitValue(baseLimit) !== limitValue(resolved);
};

export const displayedCoverageLimits = (limits, selectedUpsellIds = []) => {
  const candidates = limits || [];
  const hasLinkedLimit = candidates.some(
    (limit) => limitUpsellIds(limit).length > 0,
  );
  if (!hasLinkedLimit) return candidates;
  const resolved = resolveLimit(candidates, selectedUpsellIds);
  return resolved ? [resolved] : [];
};
